webpackJsonp([119],{

/***/ 379:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(995);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(342)("5974c068", content, true, {});

/***/ }),

/***/ 995:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(true);
// imports


// module
exports.push([module.i, ".LinkButtons1 .link-button{border-width:1px;border-style:solid}", "", {"version":3,"sources":["/Users/yuki/Public/wp-admin/src/components/contents/LinkButtons1/src/components/contents/LinkButtons1/LinkButtons1.s.scss"],"names":[],"mappings":"AAEA,2BAEI,iBAAiB,AACjB,kBAAmB,CACpB","file":"LinkButtons1.s.scss","sourcesContent":["@import '~scss/variables';\n\n.LinkButtons1 {\n  .link-button {\n    border-width: 1px;\n    border-style: solid;\n  }\n}"],"sourceRoot":""}]);

// exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/119.57cbb882c722c0032653.js